/*!--------------------------------------------------------------------------*
 *  
 *  rototo-app.js
 *  
 *--------------------------------------------------------------------------*/
;
(function($, win, doc) {

  //FUTAPPS有効化
  window.MYAPP = new FUTAPPS({
    focusInfo : {
      disabled:true
    },
    winInfo : {
      h: true,
      w: true,
      t: true
    }
  });

  //==================================================
  //  init & other
  //==================================================
  ;(function() {

    MYAPP.$Wrapper = $('#Wrapper').length>0?$('#Wrapper'):$(null);

  })();


  //==================================================
  //  browser check
  //==================================================
  ;(function() {
    var ua = navigator.userAgent.toLowerCase();

    if(ua.indexOf("windows") > 0){
      $('html').addClass('is-windowsOS');
    }

    if(MYAPP.browser.isIE){
      $('html').addClass('is-IE');
    } else if(MYAPP.browser.isTb){
      $('html').addClass('is-tablet');
    }

    if(MYAPP.browser.isTouch){
      $('html').addClass('is-touch');
    } else {
      $('html').addClass('is-mouse');
    }
  })();


  //==================================================
  //  scrolled cls
  //==================================================
  ;(function() {

    $('html').futScrollAddClass({position:50,cls:'is-scrolled'});

  })();


  //==================================================
  //  accordion
  //==================================================
  ;(function() {

    var openCls = 'is-open';

    $('.js-accordionWrap').each(function(){
      var $wrap = $(this);

      $wrap.futAccordion( {
        btnCls: 'js-accordionButton',
        contCls: 'js-accordionCont',
        openCls: openCls,
        defaultType: 'close', // 'open' or 'close' or 'none'
        duration: 400,
        after: function() {
          if(!$wrap.hasClass(openCls)){
            $wrap.find('.js-accordionWrap').removeClass(openCls).find('.js-accordionCont').removeAttr('style');
          }
        },
        before: function() {}
      });
    });

  })();


  //==================================================
  //  clone contents
  //==================================================
  ;(function() {

    $('.js-clone[data-clone]').each(function(){

      var targetSelecter = $(this).data('clone');
      var parentSelecter = $(this).data('parent');

      if(targetSelecter){

        if(parentSelecter){

          var $target = $(this).parents(parentSelecter).find(targetSelecter);

        } else {
          
          var $target = $(targetSelecter);
          
        }


        $(this).html($target.html());
      }

    });

  })();

  //==================================================
  //  pc mega menu
  //==================================================
  ;(function() {

    var $navItems = $('.rototo-header__main-nav').children('li');
    var $subnavItems = $('.rototo-header__sub-nav').children('li');
    var hoverCls = 'is-hov';

    function pcMenuInit($items) {
      $items.each(function(){

        $(this).hover(function(){

          $items.stop().clearQueue().removeClass(hoverCls);

          if(!MYAPP.browser.isTouch && ($(this).find('.rototo-header__mega').length>0 || $(this).find('.rototo-header__sub-mega').length>0 ) ){
            $(this).addClass(hoverCls);
          }

        },function(){

          $(this).delay(300).queue(function(){
            $(this).removeClass(hoverCls);
          });

        });

      });

    }



    setTimeout(function(){
      pcMenuInit($navItems.add($subnavItems));
    },300);


    
  })();

  //==================================================
  //  menu
  //==================================================
  ;(function() {

    var $menuOpen = $('.js-menuOpen');
    var $menuClose = $('.js-menuClose');
    var openCls = 'is-menuOpen';

    var $Menu = $('#Rototo-MENU');

    /* sp menu */
    $menuOpen.on('click',function(){

      $('html').toggleClass(openCls);

      if($('html').hasClass(openCls)){
        $Menu.scrollTop(0);
      }
      accordionReset();
    });

    $menuClose.on('click',function(){

      $('html').removeClass(openCls);
      accordionReset();

    });


    function accordionReset(){
      $Menu.find('.js-accordionWrap').removeClass('is-open').find('.js-accordionCont').removeAttr('style');
    }

  })();


  //==================================================
  //  fade slider
  //==================================================

  ;(function(){


    $('.js-fadeSwiper').each(function(){

      $(this).addClass('is-slideActive');

      var $slider = $(this);
      var $wrapper = $slider.find('.swiper-wrapper');

      var delay = $slider.data('delay')?$slider.data('delay'):4000;
      var speed = $slider.data('speed')?$slider.data('speed'):600;
      
      if($wrapper.find('.swiper-slide').length>=2){

        var swiper = new Swiper($slider, {
          loop: 1,
          effect: 'fade',
          slidesPerView: 1,
          slidesPerGroup:1,
          freeMode: false,
          speed: speed,
          threshold:10,
          draggable: false,
          pagination: {
            el: $slider.find('.swiper-pagination'),
            clickable: true,
          },
          fadeEffect: {
            crossFade: true
          },
          navigation: {
            nextEl: $slider.find('.swiper-arrow.-next'),
            prevEl: $slider.find('.swiper-arrow.-prev'),
          },
          autoplay: {
            delay: delay,
            disableOnInteraction: false,
          },
        });

        $slider.data('swiper',swiper);
        
      }

    });
      
  })();



  //==================================================
  //  contents slider
  //==================================================

  ;(function(){


    $.fn.slider = function(){

      $(this).each(function(){

        var $slider = $(this);
        var $wrapper = $slider.find('.swiper-wrapper');
  
        var $items = $slider.find('.swiper-slide');
  
        if($items.length===0 || $slider.hasClass('is-slideActive')) return;
  
        $slider.addClass('is-slideActive');
  
        var swiper = new Swiper($slider, {
          loop: $slider.data('loop')?true:false,
          //effect: 'fade',
          slidesPerView: 'auto',
          slidesPerGroup:1,
          freeMode: false,
          speed: 1000,
          threshold:10,
          draggable: true,
          autoplay: $slider.data('autoplay')?{
            delay: 3000,
            disableOnInteraction: false,
          }:false,
          pagination: {
            el: $slider.find('.swiper-pagination'),
            clickable: true,
          },
          navigation: {
            nextEl: $slider.find('.swiper-arrow.-next'),
            prevEl: $slider.find('.swiper-arrow.-prev'),
          },
        });
  
        $wrapper.wrap('<div class="swiper-containerInner" />');

      });

    };

    $('.js-swiper').slider();
      
  })();

  //==================================================
  //  header fixed
  //==================================================

  ;(function(){

    var $header = $('.rototo-header');
    var headerFixedCls = 'is-headerFixed';

    if($header.length===0) return;

    $(win).on('scroll.headerfixed',function(){
      if(MYAPP.winT>$header.offset().top){
        $('html').addClass(headerFixedCls);
      } else {
        $('html').removeClass(headerFixedCls);
      }
    }).trigger('scroll.headerfixed');

      
  })();

  //==================================================
  //  pagetopClass
  //==================================================

  ;(function(){

    if($('.rototo-visual-slider').length>0){
      $('body').addClass('page-top');
    }
      
  })();



  //==================================================
  //  smooth scroll
  //==================================================
  ;(function() {

    //$('a.js-scroll').futSmoothScroll();

    var adjustT = 100;

    $('a.js-scroll').each(function(){
      var dataAdjust = $(this).data('adjust');
      $(this).futSmoothScroll({before:function(options){

        if(dataAdjust || dataAdjust==0){
          adjustT=dataAdjust;
        }

        options.position = options.position-adjustT;
      }});
    })

  })();



  //==================================================
  //  custom property
  //==================================================
  ;(function() {


    $('head').append('<style id="CustomProperty"></style>');
    var $CustomProperty = $('#CustomProperty');
    var $allCustomProp = $('.js-customProp');
    var setCSS = '';
    var $target = $(null);
    var name = '';
    var css ='';
    var val = null;
    var timer  = null;


    if($allCustomProp.length===0){
      return;
    }

    $(win).on('resize.customprop load.customprop',function(){

      clearTimeout(timer);

      timer = setTimeout(function(){

        setCSS = 'html {';

        $allCustomProp.each(function(){

          $target = $(this);
          name = $target.data('name');
          css = $target.data('css');
          val = null;

          

          if($target.is(':hidden')){
            val = 0;
          } else if(css == 'height'){
            val = $target.innerHeight();
          } else if (css == 'width') {
            val = $target.innerWidth();
          } else if (css == 'top') {
            val = $target.offset().top;
          }

          if(val != null){
            setCSS += '--'+name+':'+val+'px;'
          }

        });

        setCSS += '}';

        $CustomProperty.html(setCSS);

      },20);


    }).trigger('resize.customprop');


  })();


  //==================================================
  //  prepend Text Input
  //==================================================
  ;(function() {
    $('.js-prependTextInput').each(function(){
      var $input = $(this); 
      var $label = $input.parents('label');
      var targetSelector = $input.data('target');
      var $target = $label.length>0 && targetSelector ? $(targetSelector) : $(null) ;
      var setText;
      var targetVal;
      $input.on('change',function(){
        targetVal = $target.val();
        setText = '・' + $label.text();
        if($input.is(':checked') && targetVal.indexOf(setText) === -1){
          $target.val($target.val()+(targetVal?'\n':'')+setText);
          $target.scrollTop($target.get(0).scrollHeight);
        } else if(!$input.is(':checked') && targetVal.indexOf(setText) > -1) {
          $target.val(targetVal.replaceAll('\n'+setText,'').replaceAll(setText,''));
        }
      });
    });
  })();



  //==================================================
  // product alt set
  //==================================================
  ;(function() {
    var $wrap = $('.product__media-wrapper .product__media-list');
    var $title = $('.product__title');

    $wrap.each(function(){
      var $item = $(this).find('.product__media');
      $item.each(function(){
        var alt = $(this).find('img').eq(0).attr('alt');
        if($title.text()!=alt && alt){
          $(this).append('<div class="u-pb5 u-pt5 u-pl10 u-pr10" style="bottom:0;top:auto; height:auto;background:rgba(255,255,255,.5);"><small>'+alt+'</small></div>');
        }
      });
    });
  })();


  //==================================================
  // colorLink
  //==================================================
  ;(function() {
    var $wrap = $('.js-colorLinkWrap');
    var setColor = '';
    var colorName = '';

    $wrap.find('a').each(function(){
      setColor = $(this).text().match(/#[A-Fa-f0-9]{6}/);
      if(setColor && setColor[0]){
        setColor = setColor[0];
        colorName = $(this).text().replaceAll(setColor,'').trim();
        $(this)
          .html('<span>'+colorName+'</span>')
          .attr('title',colorName)
          .css('background-color',setColor)
      }
    });
  })();


  
})(jQuery, window, document);

